export const healthCheck = (clientCode) => {
    return fetch(`https://${clientCode}.erply.com/api/health`).catch(e => false);
};
